/**
 * assets/dm-video-visible.js — plays a `dm-media-frame` muted loop only while
 * it is actually displayed (the frame's `play_when_visible` param).
 *
 * Those videos are rendered without `autoplay` and with `preload="none"`, so
 * nothing downloads until this decides. A video counts as displayed when it
 * has a layout box (`getClientRects()`): a clip inside a `display: none`
 * breakpoint wrapper has none, so it never loads or plays. Re-checked when
 * the viewport crosses a breakpoint, when the reduced-motion preference
 * changes, and when the theme editor reloads a section. Under
 * `prefers-reduced-motion: reduce` nothing plays; the CSS shows the poster.
 *
 * Classic script, `defer`, emitted once per frame, so the setup is guarded.
 */
(function () {
  'use strict';
  if (window.dmVideoVisible) return;

  const SELECTOR = '.dm-media-frame--play-visible > video';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function sync() {
    document.querySelectorAll(SELECTOR).forEach((video) => {
      const shown = video.getClientRects().length > 0;
      if (shown && !reduce.matches) {
        if (video.preload === 'none') video.preload = 'auto';
        if (video.paused) {
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
      } else if (!video.paused) {
        video.pause();
      }
    });
  }

  let timer;
  const later = () => { clearTimeout(timer); timer = setTimeout(sync, 150); };

  window.dmVideoVisible = { sync };
  window.addEventListener('resize', later);
  reduce.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', later);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
